import { DoctorDirectoryContainer, HeaderDirectory,Container, Logo, LogoIcon, Subtitle, Country, Button  } from "../styles/DoctorDirectory.style";
import LogoEupha from '../assets/Helixor/logo-eupha.png'
import LogoHelixor from '../assets/Helixor/helixor-logo.png'
import DirectoryComponent from "../components/Directory/Directory";

const DoctorDirectory = () => {
    return (
        <DoctorDirectoryContainer>
        <Container>
      <Logo>
        <img src={LogoHelixor} alt="Logo Helixor" />
      </Logo>
      <Subtitle>ESPECIALISTAS EN</Subtitle>
      <Country>Guatemala</Country>
      <Button>CONTÁCTALOS</Button>
    </Container>
    <DirectoryComponent />
        </DoctorDirectoryContainer>
    );
}

export default DoctorDirectory